import { Component, OnInit } from '@angular/core'
import { CredentialsService } from '@app/core'
import { SCShellService } from '@symblcrowd/ng-symblcrowd'
import { filter } from 'rxjs/operators'
import { ShellService } from './shell.service'

@Component({
  selector: 'app-shell',
  template: `
    <sc-shell></sc-shell>
  `
})
export class ShellComponent implements OnInit {
  constructor(public shellService: ShellService, public scShellService: SCShellService, private credentialsService: CredentialsService) {}

  ngOnInit() {
    if (window.opener && window.opener !== window && window.name != '') {
      this.scShellService.inPopupWindowOpened = true
    }

    this.scShellService.isInit = true //Edit when Backend Ready

    this.credentialsService.$credentials.pipe(filter(credentials => !!credentials && !!credentials.id)).subscribe(credentials => {
      if (credentials.theme) {
        document.body.classList.add(credentials.theme)
      }
      this.scShellService.isInit = true
    })
  }
}
